import QRCode from 'qrcode.react'
import React, { useContext, useEffect, useState } from 'react'
import toastError from '../../errors/toastError'

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@material-ui/core'
import { ExtensionOutlined } from '@material-ui/icons'
import { QrCode } from 'lucide-react'
import { SocketContext } from '../../context/Socket/SocketContext'
import api from '../../services/api'
import { i18n } from '../../translate/i18n'
import { useStyles } from './style'

const QrcodeModal = ({ open, onClose, whatsAppId, onOpenPasskeyModal, connectorReady = false }) => {
  const classes = useStyles()
  const [qrCode, setQrCode] = useState('')
  const [requestingCapture, setRequestingCapture] = useState(false)

  const socketManager = useContext(SocketContext)

  useEffect(() => {
    const fetchSession = async () => {
      if (!whatsAppId) return

      try {
        const { data } = await api.get(`/whatsapp/${whatsAppId}`)
        setQrCode(data.qrcode)
      } catch (err) {
        toastError(err)
      }
    }
    fetchSession()
  }, [whatsAppId])

  useEffect(() => {
    if (!whatsAppId) return
    const companyId = localStorage.getItem('companyId')
    const socket = socketManager.GetSocket(companyId)

    const onCompanyWhatsappSession = data => {
      if (data.action === 'update' && data.session.id === whatsAppId) {
        setQrCode(data.session.qrcode)

        if (data.session.status === 'passkey_required' && onOpenPasskeyModal) {
          onOpenPasskeyModal()
        }
      }

      if (data.action === 'update' && data.session.qrcode === '') {
        onClose()
      }
    }

    socket.on(`company-${companyId}-whatsappSession`, onCompanyWhatsappSession)

    return () => {
      socket.disconnect()
    }
  }, [whatsAppId, onClose, socketManager, onOpenPasskeyModal])

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" scroll="paper">
      <DialogTitle className={classes.dialogTitle}>
        Escaneie o QRCode para conectar.
      </DialogTitle>
      <DialogContent dividers>
        {qrCode ? (
          <div className={classes.qrcodeContainer}>
            <QRCode className={classes.qrcodeFrame} value={qrCode} size={256} />
          </div>
        ) : (
          // <span>Waiting for QR Code</span>
          <div className={classes.qrcodeWaiting}>
            <QrCode size={150} />
            <span>Aguardando gerar o QR Code</span>
          </div>
        )}
        {connectorReady && (
          <Button
            variant="contained"
            color="primary"
            size="small"
            disabled={requestingCapture}
            startIcon={<ExtensionOutlined />}
            onClick={async () => {
              if (!whatsAppId) return
              setRequestingCapture(true)
              try {
                await api.post(`/whatsappsession/${whatsAppId}/capture-token`)
              } catch (err) {
                toastError(err)
              } finally {
                setRequestingCapture(false)
              }
            }}
          >
            {i18n.t('qrCode.startCapture')}
          </Button>
        )}
        {!connectorReady && onOpenPasskeyModal && (
          <Button
            variant="outlined"
            color="primary"
            size="small"
            startIcon={<ExtensionOutlined />}
            onClick={onOpenPasskeyModal}
          >
            {i18n.t('qrCode.installExtension')}
          </Button>
        )}
        {onOpenPasskeyModal && (
          <Typography className={classes.qrcodeInfo} variant="body2">
            {i18n.t('qrCode.extensionHint')}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <span className={classes.qrcodeInfo}>
          Para concluir a conexão, abra o WhatsApp no seu dispositivo móvel e
          escaneie o QR Code exibido aqui. Isso permitirá a sincronização e o
          início do atendimento integrado no sistema.
        </span>
      </DialogActions>
    </Dialog>
  )
}

export default React.memo(QrcodeModal)
